module.exports = ".container {\r\n  padding: 2rem;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-release/edit-release/edit-release.component.css
// module id = ./src/app/components/app-release/edit-release/edit-release.component.css
// module chunks = main